export function joinJSXElement(res: JSX.Element[]) {
    const length = res.length - 1

    return res.map((item: JSX.Element, key: number) => {
        if (key === 0) {
            return item
        } else if (length === key) {
            return <> и&nbsp;{item}</>
        } else {
            return <>, {item}</>
        }
    })
}
